import { apiClient, type PageData } from './client'

export interface StoreProduct {
	id: number
	store_name: string
	store_info?: string
	image: string
	slider_image: string
	price: string
	ot_price?: string
	cost?: string
	vip_price: string
	keyword?: string
	unit_name?: string
	stock: number
	sales: number
	cate_id?: string
	cate_name?: string
	brand_id?: number
	brand_name?: string
	is_show: number
	is_del: number
	is_hot?: number
	is_benefit?: number
	is_best?: number
	is_new?: number
	spec_type?: number
	product_type?: number
	supplier_id?: number
	real_stock?: number
	add_time?: number
}

export interface StoreProductAttrValue {
	id: number
	product_id: number
	suk: string
	price: string
	cost: string
	stock: number
	sum_stock: number
	sales: number
	image: string
	unique: string
	bar_code: string
	code: string
}

export interface StoreProductDetail {
	id: number
	store_name: string
	store_info?: string
	image: string
	slider_image: string
	price: string
	ot_price?: string
	cost?: string
	vip_price: string
	keyword?: string
	unit_name?: string
	stock: number
	sales: number
	cate_id?: string
	brand_id?: number
	is_show: number
	is_del: number
	is_hot?: number
	is_benefit?: number
	is_best?: number
	is_new?: number
	spec_type?: number
	product_type?: number
	sort?: number
	add_time?: number
	bar_code?: string
	code?: string
	attr_value: StoreProductAttrValue[]
}

export interface StoreBrand {
	id: number
	brand_name: string
}

export interface StoreCategory {
	id: number
	pid: number
	cate_name: string
}

export interface ProductListParams {
	field_key?: string
	keyword?: string
	status?: number
	cate_id?: number
	brand_id?: number
	product_type?: number
	delivery_type?: number
	spec_type?: number
	price_min?: string
	price_max?: string
	stock_min?: number
	stock_max?: number
	sales_min?: number
	sales_max?: number
	create_time_min?: string
	create_time_max?: string
	store_label_id?: number
	supplier_id?: number
	sales?: string
	page?: number
	page_size?: number
}

export interface StockUpdateAttr {
	unique: string
	pm: 0 | 1
	stock: number
}

export interface StockRecord {
	id: number
	product_id: number
	unique: string
	suk?: string
	cost_price: string
	number: number
	pm: number // 1:入库 0:出库
	add_time: number
}

const buildProductSearch = (params: ProductListParams) => {
	const search = new URLSearchParams()
	if (params.field_key) search.set('field_key', params.field_key)
	if (params.keyword) search.set('keyword', params.keyword)
	if (params.status) search.set('status', String(params.status))
	if (params.cate_id) search.set('cate_id', String(params.cate_id))
	if (params.brand_id) search.set('brand_id', String(params.brand_id))
	if (params.product_type !== undefined) search.set('product_type', String(params.product_type))
	if (params.delivery_type) search.set('delivery_type', String(params.delivery_type))
	if (params.spec_type !== undefined) search.set('spec_type', String(params.spec_type))
	if (params.price_min) search.set('price_min', params.price_min)
	if (params.price_max) search.set('price_max', params.price_max)
	if (params.stock_min) search.set('stock_min', String(params.stock_min))
	if (params.stock_max) search.set('stock_max', String(params.stock_max))
	if (params.sales_min) search.set('sales_min', String(params.sales_min))
	if (params.sales_max) search.set('sales_max', String(params.sales_max))
	if (params.create_time_min) search.set('create_time_min', params.create_time_min)
	if (params.create_time_max) search.set('create_time_max', params.create_time_max)
	if (params.store_label_id) search.set('store_label_id', String(params.store_label_id))
	if (params.supplier_id) search.set('supplier_id', String(params.supplier_id))
	if (params.sales) search.set('sales', params.sales)
	search.set('page', String(params.page ?? 1))
	search.set('page_size', String(params.page_size ?? 30))
	return search
}

export const productsApi = {
	list: async (params: ProductListParams) => {
		const response = await apiClient.get<PageData<StoreProduct>>(`/products?${buildProductSearch(params)}`)
		return response.data
	},
	getDetail: async (id: number) => {
		const response = await apiClient.get<StoreProductDetail>(`/products/${id}`)
		return response.data
	},
	updateStock: async (id: number, attrs: StockUpdateAttr[]) => {
		const response = await apiClient.put<{ stock: number }>(`/products/${id}/stock`, { attrs })
		return response.data
	},
	listBrands: async () => {
		const response = await apiClient.get<StoreBrand[]>('/products/brands')
		return response.data
	},
	listCategories: async () => {
		const response = await apiClient.get<StoreCategory[]>('/products/categories')
		return response.data
	},
	listStockRecords: async (id: number, page = 1, pageSize = 20) => {
		const response = await apiClient.get<PageData<StockRecord>>(`/products/${id}/stock-records?page=${page}&page_size=${pageSize}`)
		return response.data
	},
}
